import { IAccountStatus } from 'services/rtk/fbmanager/types/account';
import { IAdStatus } from 'services/rtk/fbmanager/types/ad';
import { IAdsetStatus } from 'services/rtk/fbmanager/types/adset';
import { ICabStatus } from 'services/rtk/fbmanager/types/cab';
import { ICampaignStatus } from 'services/rtk/fbmanager/types/campaign';

export enum FBFiltersActionTypes {
  SET_ACCOUNTS_STATUSES = 'SET_ACCOUNTS_STATUSES',
  SET_CABS_STATUSES = 'SET_CABS_STATUSES',
  SET_CAMPAIGNS_STATUSES = 'SET_CAMPAIGNS_STATUSES',
  SET_ADSETS_STATUSES = 'SET_ADSETS_STATUSES',
  SET_ADS_STATUSES = 'SET_ADS_STATUSES',
  SET_SEARCH = 'SET_SEARCH',
  SET_SEARCH_PROXY = 'SET_SEARCH_PROXY',
  SET_PROXY_FILTER = 'SET_PROXY_FILTER',
}

interface ISetAccountsStatusesAction {
  type: FBFiltersActionTypes.SET_ACCOUNTS_STATUSES;
  payload: IAccountStatus[];
}

interface ISetCabsStatusesAction {
  type: FBFiltersActionTypes.SET_CABS_STATUSES;
  payload: ICabStatus[];
}

interface ISetCampaignsStatusesAction {
  type: FBFiltersActionTypes.SET_CAMPAIGNS_STATUSES;
  payload: ICampaignStatus[];
}

interface ISetAdsetsStatusesAction {
  type: FBFiltersActionTypes.SET_ADSETS_STATUSES;
  payload: IAdsetStatus[];
}

interface ISetAdsStatusesAction {
  type: FBFiltersActionTypes.SET_ADS_STATUSES;
  payload: IAdStatus[];
}

interface ISetSearchProxyAction {
  type: FBFiltersActionTypes.SET_SEARCH_PROXY;
  payload: string;
}

interface ISetSearchAction {
  type: FBFiltersActionTypes.SET_SEARCH;
  payload: string;
}

interface ISetProxyFilterAction {
  type: FBFiltersActionTypes.SET_PROXY_FILTER;
  payload: number | undefined;
}

export type TFBFiltersActions =
  | ISetAccountsStatusesAction
  | ISetCabsStatusesAction
  | ISetCampaignsStatusesAction
  | ISetAdsetsStatusesAction
  | ISetAdsStatusesAction
  | ISetProxyFilterAction
  | ISetSearchProxyAction
  | ISetSearchAction;

export const setFBAccountsStatusesFilter = (payload: IAccountStatus[]): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_ACCOUNTS_STATUSES,
  payload,
});

export const setFBCabsStatusesFilter = (payload: ICabStatus[]): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_CABS_STATUSES,
  payload,
});

export const setFBCampaignsStatusesFilter = (payload: ICampaignStatus[]): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_CAMPAIGNS_STATUSES,
  payload,
});

export const setFBAdsetsStatusesFilter = (payload: IAdsetStatus[]): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_ADSETS_STATUSES,
  payload,
});

export const setFBAdsStatusesFilter = (payload: IAdStatus[]): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_ADS_STATUSES,
  payload,
});

export const setSearchFBProxyFilter = (payload: string): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_SEARCH_PROXY,
  payload,
});

export const setSearchFilter = (payload: string): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_SEARCH,
  payload,
});

export const setFBProxyFilter = (payload: number | undefined): TFBFiltersActions => ({
  type: FBFiltersActionTypes.SET_PROXY_FILTER,
  payload,
});
